// extracted by mini-css-extract-plugin
export default {"Btn":"PrimaryBtn_Btn__ZRIAV","BtnIcon":"PrimaryBtn_BtnIcon__9nIRS","BtnDanger":"PrimaryBtn_BtnDanger__NmEOx","BtnDangerIcon":"PrimaryBtn_BtnDangerIcon__3Bvpv"};